/* global locales */
import angular from 'angular';
import 'angular-bootstrap';
import 'ui-select';
import locales from '../../locale';
import 'angular-bootstrap-colorpicker/js/bootstrap-colorpicker-module';
import 'angular-bootstrap-colorpicker/css/colorpicker.css';

import './couponsServices';

'use strict';

const couponsControllers = angular.module('applicationModule.couponsControllers', [
    'applicationModule.couponsServices',
    'colorpicker.module',
    'ui.bootstrap'
]);

couponsControllers.controller('CouponsController', ['$scope', '$rootScope', '$stateParams', '$filter', '$state', 'NgTableParams', 'Coupon', 'growl', 'AppsoupAPI', 'Permissions', '$modal', function ($scope, $rootScope, $stateParams, $filter, $state, NgTableParams, Coupon, growl, AppsoupAPI, Permissions, $modal) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('coupons');
    $scope.app_id = $stateParams.application_id;
    $scope.checkedCoupons = [];
    $scope.date = {};
    $scope.allCouponsBtnChecked = false;
    $scope.selectedCoupons = [];
    $scope.isActive = false;
    $scope.isLoadingSelectedExport = false;
    $scope.check = false;
    $scope.search = {};
    $scope.searchItem = null;
    $scope.activeOption = 'user_actived';
    $scope.activeOptions = [];
    $scope.canEditShopId = false;
    $scope.statusLabels = [];
    $scope.shop_ids = [];
    $scope.couponTypes = [{text: 'MODULES.COUPONS.LABEL.GLOBAL', value: 'global'}, {
        text: 'MODULES.COUPONS.LABEL.LOCAL',
        value: 'local'
    }];
    $scope.couponDelikatesyTypes = [{
        text: 'MODULES.COUPONS.LABEL.COUPON',
        value: 'coupon'
    }, {text: 'MODULES.COUPONS.LABEL.SCRATCH_CARD', value: 'scratch_card'}];
    var refresh = true;
    $scope.clause1 = 'Oferta tylko dla Twojej Delikarty o numerze {card-number} dostępna w wybranych sklepach po aktywowaniu kuponu. Lista wybranych sklepów znajduje się tu: <a href="http://www.delikarta.pl/sklepy">www.delikarta.pl/sklepy</a> i <a href="http://www.delikarta.pl/mini">www.delikarta.pl/mini</a>. W okresie trwania promocji możesz maksymalnie kupić w promocyjnej cenie ilość wskazaną przy danym produkcie. Podane ceny to ceny maksymalne. Każdy sklep może stosować własne ceny, nie wyższe niż wskazane.';
    $scope.clause2 = 'Oferta tylko z aktywną Delikartą. <a href="delicentrum://delicentrum?destination=register">Aktywuj konto</a>, by skorzystać z promocji.';

    $scope.tableParams = new NgTableParams(AppsoupAPI.getByOrderDescTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Coupon.getList($scope.app_id, params._params).then(function (response) {
                params.total(response.coupons.total);
                params.count(response.coupons.per_page);
                params.page(response.coupons.current_page);
                $scope.package_id = response.package_id;

                if (angular.isDefinedNotNull($stateParams.searchCoupons)) {
                    $scope.search = $stateParams.searchCoupons;
                    $scope.searchCoupons($scope.search);
                }
                if (response.useShopId) {
                    $scope.getDataToShop();
                }

                return response.coupons.data;
            }).finally(function () {
                $scope.isLoading = false;
                $scope.isFind = false;
            });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.getDataToShop = function () {
        Coupon.getActiveOptions().then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.activeOptions = data.activeOptions;
            }
        });
        Coupon.getStatusLabels($scope.app_id).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.canEditShopId = data.canEditShopId;
                $scope.userExternalId = data.userExternalId;
                $scope.statusLabels = data.statusLabels;
                $scope.allStatuses = data.allStatuses;
            }
        });
    };

    $scope.newCoupon = function () {
        var userExternalId = ($scope.userExternalId ? [$scope.userExternalId] : null);
        var modalInstance = $modal.open({
            templateUrl: 'views/application/coupons/coupon.tpl.html',
            controller: 'CouponModalController',
            backdrop: 'static',
            animation: true,
            resolve: {
                coupon: function () {
                    return {
                        app_id: $scope.app_id,
                        package_id: $scope.package_id,
                        clause_1: $scope.clause1,
                        clause_2: $scope.clause2,
                        active: $scope.activeOption,
                        activeOptions: $scope.activeOptions,
                        canEditShopId: $scope.canEditShopId,
                        userExternalId: $scope.userExternalId,
                        shop_id: $scope.canEditShopId ? null : userExternalId,
                        statusLabels: $scope.statusLabels,
                        published: 3
                    };
                }
            }
        });
        modalInstance.result.then(function (coupon) {
            $scope.tableParams.data.unshift(coupon);
        }).catch(() => {});
    };

    $scope.editCoupon = function (couponId, index) {
        Coupon.get(couponId).then(function (result) {
            let data = result.data;

            if (data.success) {
                if (data.coupon.active == null) {
                    data.coupon.active = $scope.activeOption;
                }
                if (data.coupon.shop_id !== null) {
                    $scope.shop_id = data.coupon.shop_id;
                }
                if (!(data.coupon.published in $scope.statusLabels)) {
                    data.coupon.published = Object.keys($scope.statusLabels)[0];
                }
                var modalInstance = $modal.open({
                    templateUrl: 'views/application/coupons/coupon.tpl.html',
                    controller: 'CouponModalController',
                    backdrop: 'static',
                    animation: true,
                    resolve: {
                        coupon: function () {
                            return Object.assign(data.coupon, {
                                package_id: $scope.package_id,
                                activeOptions: $scope.activeOptions,
                                canEditShopId: $scope.canEditShopId,
                                userExternalId: $scope.userExternalId,
                                statusLabels: $scope.statusLabels
                            });
                        }
                    }
                });
                modalInstance.result.then(function (coupon) {
                    $scope.tableParams.data[index] = coupon;
                }).catch(() => {});
            } else {
                growl.error('MODULES.COUPONS.' + data.error);
            }
        });
    };

    $scope.selectCoupon = function (id) {
        $scope.checkedCoupons = angular.selectElement($scope.checkedCoupons, id);
    };

    $scope.checkActive = function (item) {
        $scope.isActive = item.isActive;
    };

    $scope.remove = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.removeCoupon = function (id, index) {
        Coupon.remove(id, $scope.app_id).then(function (result) {
            let data = result.data;

            if (data.success) {
                growl.success('MODULES.COUPONS.SUCCESS.DELETED');
                $scope.tableParams.data.splice(index, 1);
            } else {
                growl.error('MODULES.COUPONS.ERROR.DELETED');
            }
        });
    };

    $scope.searchCoupons = function (search) {
        $scope.isFind = true;

        search.from_date = $filter('date')(search.from_date, 'yyyy-MM-dd');
        search.to_date = $filter('date')(search.to_date, 'yyyy-MM-dd');

        var find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.searchItem = $scope.search;
        $scope.isFind = false;
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.name)) {
            $scope.tableParams._params.name = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.status_label)) {
            $scope.tableParams._params.status_label = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.type_coupon)) {
            $scope.tableParams._params.type_coupon = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.type_coupon_ids)) {
            $scope.tableParams._params.type_coupon_ids = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.type_coupon_delikatesy)) {
            $scope.tableParams._params.type_coupon_delikatesy = undefined;
        }
        $stateParams.searchCoupons = null;
        $scope.searchItem = null;
    };

    $scope.$watch('search', function () {
        $scope.check = false;
        angular.forEach($scope.search, function (val) {
            if (angular.isDefined(val) && angular.isDefinedNotEmpty(val)) {
                $scope.check = true;
            }
            if (angular.isDefined($scope.tableParams._params.from_date)) {
                $scope.tableParams._params.from_date = undefined;
            }
            if (angular.isDefined($scope.tableParams._params.to_date)) {
                $scope.tableParams._params.to_date = undefined;
            }
        });
    }, true);

    $scope.exportDataById = function (appId, couponId) {
        $scope.exportedCouponId = couponId;
        $scope.isLoadingExport = true;
        if ($scope.isLoading) {
            growl.info('GROWL.INFO.EXPORT');
        }
        Coupon.exportDataById($scope.app_id, couponId)
            .then(function (result) {
                let data = result.data;

                if (data) {
                    angular.openInNewTab(data);
                    growl.success('GROWL.SUCCESS.EXPORT');
                } else {
                    growl.error(data.error);
                }
            }).finally(function () {
            $scope.isLoading = false;
            $scope.isLoadingExport = false;
            $scope.exportedCouponId = 0;
        });
    };

    $scope.exportData = function (from_date, to_date) {
        $scope.isLoadingExportAll = true;
        if ($scope.isLoadingExportAll) {
            growl.info('GROWL.INFO.EXPORT');
        }
        Coupon.exportData(from_date, to_date, $scope.app_id, $scope.checkedCoupons, $scope.isActive)
            .then(function (result) {
                let data = result.data;

                if (angular.isDefined(data.error)) {
                    growl.error(data.error);
                } else if (data) {
                    angular.openInNewTab(data);
                    growl.success('GROWL.SUCCESS.EXPORT');
                } else {
                    growl.error(data.error);
                }
            }).finally(function () {
            $scope.isLoading = false;
            $scope.isLoadingExportAll = false;
        });
    };

    $scope.selectAllCoupons = function (item) {
        $scope.checkedCoupons = angular.selectAllElements($scope.checkedCoupons, item);
    };

    $scope.checkSelectedCoupons = function (item) {
        return angular.checkSelectedElements($scope.checkedCoupons, item);
    };

    $scope.changeOrder = function ($event, key1, key2) {
        var data = $scope.tableParams.data;
        $event.stopImmediatePropagation();
        Coupon.changeOrder({
            order_ids: [$scope.tableParams.data[key1].order, $scope.tableParams.data[key2].order],
            application_id: $scope.application_id
        })
            .then(function (response) {
                if (response.data.success) {
                    data = angular.changeOrderResponse(data, key1, key2);
                }
            });
        $scope.tableParams.data = data;
    };

    function refreshData() {
        $scope.searchCoupons({refresh: refresh});
        refresh = !refresh;
        $scope.checkedCoupons = [];
    }

    $scope.publish = function () {
        Coupon.publish($scope.app_id, $scope.checkedCoupons).then(function (result) {
            let data = result.data;

            if (data.success) {
                growl.success('MODULES.COUPONS.SUCCESS.PUBLISHED');
            } else {
                growl.error('MODULES.COUPONS.ERROR.PUBLISHED');
            }
        }).catch(function () {
            growl.error('MODULES.COUPONS.ERROR.PUBLISHED');
        }).finally(function () {
            refreshData();
        });
    };

    $scope.selectCoupons = function (id) {
        $scope.checkedCoupons = angular.selectElement($scope.checkedCoupons, id);
    };

    $scope.searchShops = function (text) {
        if (text) {
            Coupon.searchShop($scope.app_id, text).then(function (result) {
                let data = result.data;

                if (data.success) {
                    $scope.shop_ids = data.shopIds;
                }
            });
        }
    };

}]);

couponsControllers.controller('CouponModalController', ['$scope', '$rootScope', '$stateParams', '$state', 'Coupon', 'coupon', 'growl', 'Permissions', '$modal', '$modalInstance', '$filter', function ($scope, $rootScope, $stateParams, $state, Coupon, coupon, growl, Permissions, $modal, $modalInstance, $filter) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('coupons');
    var app_id = $stateParams.application_id;
    $scope.badgeTypes = [];
    $scope.types = [];
    $scope.scratchCardTypes = [];
    $scope.editMode = false;
    $scope.fileContent = undefined;
    $scope.coupon = {
        app_id: app_id,
        status: true
    };
    $scope.placements = [];
    $scope.inputErrors = {};
    $scope.formErrors = {};
    $scope.shop_id = [];

    $scope.lang = $filter('translate')('LANG');
    $scope.tinymceOptions = angular.getTinymceOptionsBr($modal, 100);

    if (angular.isDefined($scope.lang) && $scope.lang !== 'en') {
        $scope.tinymceOptions['language'] = $scope.lang;
        $scope.tinymceOptions['language_url'] = '/assets/tinymce/' + $scope.lang + '.js';
    }

    $scope.tinymceCounter = {
        min_height: 50,
        toolbar: 'bold',
        menubar: false,
        statusbar: false,
        force_br_newlines: true,
        force_p_newlines: false,
        forced_root_block: ''
    };

    $scope.tinymceClause = {
        plugins: 'link',
        toolbar: 'link',
        menubar: false,
        statusbar: false,
        force_br_newlines: true,
        force_p_newlines: false,
        forced_root_block: ''
    };

    if (coupon) {
        $scope.coupon = coupon;

        if (coupon.id) {
            $scope.editMode = true;
        }
    }

    $scope.autocompletePlacement = function (text) {
        text = encodeURIComponent(text);

        Coupon.autocompletePlacement(app_id, text)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    $scope.placements = data.placements;
                }
            });
    };

    Coupon.getBadgeTypes(app_id)
        .then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.badgeTypes = data.badgeTypes;
                if ($scope.badgeTypes.length > 0) {
                    $scope.coupon.badge = {};
                }
            }
        });

    Coupon.getTypes(app_id)
        .then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.types = data.types;
            }
        });

    Coupon.getScratchCardTypes(app_id)
        .then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.scratchCardTypes = data.scratchCardTypes;
            }
        });

    $scope.changeStartDate = function () {
        if ($scope.coupon.type && $scope.coupon.type === 'daily') {
            $scope.coupon.validity_date = $scope.coupon.start_date;
        }
    };

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        if ($scope.couponForm.$valid) {
            $scope.isLoading = true;
            $scope.coupon.validity_date = $filter('date')($scope.coupon.validity_date, 'yyyy-MM-dd');
            Coupon.save($scope.coupon, $scope.editMode).then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.COUPONS.SUCCESS.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                    $modalInstance.close(data.coupon);
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.COUPONS.ERROR.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                    }
                }
                if (data.errorImgSize) {
                    growl.error(data.errorImgSize);
                }
            }).finally(function () {
                $scope.isLoading = false;
            });
        }
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.removeFile = function () {
        $scope.coupon.contractors = null;
    };

    $scope.searchShops = function (text) {
        if (text) {
            Coupon.searchShop(app_id, text).then(function (result) {
                let data = result.data;

                if (data.success) {
                    $scope.shop_id = data.shopIds;
                }
            });
        }
    };

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'ERROR.REQUIRED'}],
        'image': [{type: '$invalid', msg: 'ERROR.REQUIRED'}],
        'small_image': [{type: '$invalid', msg: 'ERROR.REQUIRED'}],
        'counter': [{type: '$invalid', msg: 'ERROR.REQUIRED'}],
        'btn_text': [{type: 'required', msg: 'ERROR.REQUIRED'}, {
            error: 'maxlength',
            msg: 'ERROR.MAX.STRING',
            vars: '{ maxLength: 50 }'
        }],
        'placement': [{type: '$invalid', msg: 'ERROR.REQUIRED'}],
        'budget_info': [{error: 'maxlength', msg: 'ERROR.MAX.STRING', vars: '{ maxLength: 150 }'}],
        'accept_info': [{error: 'maxlength', msg: 'ERROR.MAX.STRING', vars: '{ maxLength: 50 }'}],
        'validity_date_info': [{error: 'maxlength', msg: 'ERROR.MAX.STRING', vars: '{ maxLength: 100 }'}],
        'validity_date': [{type: '$invalid', msg: 'ERROR.DATE'}],
        'font_color': [{type: '$invalid', msg: 'ERROR.INVALID_FORMAT'}],
        'background_color': [{type: '$invalid', msg: 'ERROR.INVALID_FORMAT'}],
        'btn_text_color': [{type: '$invalid', msg: 'ERROR.INVALID_FORMAT'}],
        'btn_background_color': [{type: '$invalid', msg: 'ERROR.INVALID_FORMAT'}],
        'remaining_coupons_text_color': [{type: '$invalid', msg: 'ERROR.INVALID_FORMAT'}],
        'remaining_background_color': [{type: '$invalid', msg: 'ERROR.INVALID_FORMAT'}],
        'coupon_text': [{error: 'maxlength', msg: 'ERROR.MAX.STRING', vars: '{ maxLength: 120 }'}],
        'price': [{error: 'pattern', msg: 'ERROR.PRICE_FORMAT'}],
        'coupon_omnibus_price': [{error: 'pattern', msg: 'ERROR.PRICE_FORMAT'}],
        'short_coupon_omnibus_price': [{error: 'pattern', msg: 'ERROR.PRICE_FORMAT'}],
        'remaining_coupons_text': [{error: 'maxlength', msg: 'ERROR.MAX.STRING', vars: '{ maxLength: 120 }'}],
        'forcom_segment_id': [{type: '$invalid', msg: 'ERROR.REQUIRED'}],
        'forcom_counter_id': [{type: '$invalid', msg: 'ERROR.REQUIRED'}],
        'start_date1': [{type: '$invalid', msg: 'ERROR.REQUIRED'}],
        'validity_date1': [{type: '$invalid', msg: 'ERROR.REQUIRED'}],
        'badgeType': [{type: '$invalid', msg: 'ERROR.REQUIRED'}],
        'badgeElement1': [{type: '$invalid', msg: 'ERROR.REQUIRED'}],
        'badgeElement2': [{type: '$invalid', msg: 'ERROR.REQUIRED'}],
        'badgeElement3': [{type: '$invalid', msg: 'ERROR.REQUIRED'}],
        'ean': [{type: '$invalid', msg: 'ERROR.INVALID_FORMAT'}],
        'additional_description': [{type: '$invalid', msg: 'ERROR.REQUIRED'}]
    };

    $scope.$watch('fileContent', function () {
        if ($scope.fileContent) {
            if ($scope.fileContent[0] && $scope.fileContent[0][0] && $scope.fileContent[0][0].indexOf('.csv') === -1) {
                growl.error('ERROR.CONTRACTOR.INVALID_FORMAT');
            } else if (!($scope.fileContent[1] && $scope.fileContent[1].length && $scope.fileContent[1].length === 1)) {
                growl.error('ERROR.CONTRACTOR.COLUMN_NUMBER');
            } else {
                $scope.fileContent = $scope.fileContent.map(function (row) {
                    return row[0];
                });

                $scope.coupon.contractors = $scope.fileContent;
            }

            delete $scope.fileContent;
        }
    });
    $scope.$watch('coupon.additional_description', function () {
        if ($scope.coupon.additional_description) {
            delete $scope.formErrors.additional_description;
        }
    });

    $scope.$watch('coupon.reward_value', function () {
        if ($scope.coupon.reward_value) {
            delete $scope.formErrors.reward_value;
        }
    });
}]);

couponsControllers.controller('CouponImportController', ['$state', '$scope', '$rootScope', '$stateParams', 'growl', 'Coupon', '$filter', '$locale', function ($state, $scope, $rootScope, $stateParams, growl, Coupon, $filter, $locale) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.application_id = $stateParams.application_id;
    $scope.couponId = $stateParams.couponId;
    $scope.lang = $filter('translate')('LANG');
    if (locales[$scope.lang] && locales[$scope.lang].DATETIME_FORMATS) {
        angular.copy(locales[$scope.lang].DATETIME_FORMATS, $locale.DATETIME_FORMATS);
    }
    $scope.editMode = false;

    $scope.requiredFields = [
        '"contractor"',
        '"sku"',
        '"budget_value"',
        '"unit"'
    ];

    $scope.upload = undefined;
    $scope.fileUploaded = false;
    $scope.errorRequired = false;

    Coupon.getCouponData($scope.application_id, $scope.couponId)
        .then(function (result) {
            let data = result.data;

            if (data.success) {
                if (angular.isDefinedNotNull(data.couponData) && angular.isDefined(data.couponData.file_name)) {
                    $scope.file_name = data.couponData.file_name;
                }
            }
        });

    $scope.removeFile = function () {
        $scope.upload = undefined;
        $scope.errorRequired = true;
        $scope.fileUploaded = false;
    };

    $scope.uploadSuccess = function (file) {
        $scope.upload = file;
        $scope.errorRequired = false;
        $scope.fileUploaded = true;
        $scope.fileError = false;
        $scope.$apply();
    };

    $scope.getExampleXls = function () {
        $scope.isLoading = false;
        Coupon.getExampleXls().then(function (result) {
            let data = result.data;

            angular.openInNewTab(data);
        }).finally(function () {
            $scope.isLoading = false;
        });
    };

    $scope.importData = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;
        $scope.wrongData = [];
        Coupon.importData($scope.application_id, $scope.couponId, $scope.upload).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.imported = true;
                $scope.wrongData = data.wrongData;
                growl.success('MODULES.APPLICATIONS.MODULES.USERS.IMPORT.SUCCESS');
                if ($scope.wrongData.length <= 0) {
                    $state.go('appsoup.application.coupons');
                }
            } else {
                growl.error(data.error, {title: 'IMPORT.HEADER.DEFAULT'});
            }
        }).finally(function () {
            $scope.isLoading = false;
        });
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.coupons');
    };

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'MODULES.COUPONS.ERROR.NAME'}]
    };
}]);

couponsControllers.controller('CouponImportShopsController', ['$state', '$scope', '$rootScope', '$stateParams', 'NgTableParams', 'AppsoupAPI', 'growl', 'Coupon', '$filter', '$locale', function ($state, $scope, $rootScope, $stateParams, NgTableParams, AppsoupAPI, growl, Coupon, $filter, $locale) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.application_id = $stateParams.application_id;
    $scope.couponId = $stateParams.couponId;

    $scope.lang = $filter('translate')('LANG');
    if (locales[$scope.lang] && locales[$scope.lang].DATETIME_FORMATS) {
        angular.copy(locales[$scope.lang].DATETIME_FORMATS, $locale.DATETIME_FORMATS);
    }
    $scope.editMode = false;
    var refresh = true;
    $scope.show_limited_stores_ui = false;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getByOrderDescTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;

            return Coupon.getImportedShopList($scope.application_id, $scope.couponId, params._params).then(function (response) {
                return response.shops;
            }).finally(function () {
                $scope.isLoading = false;
                $scope.isFind = false;
            });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    Coupon.getShopsByCoupon($scope.application_id, $scope.couponId).then(function (response) {
        if (response.data.success) {
            if (response.data.shops.shops.length > 0) {
                $scope.coupon = response.data.shops;
                $scope.showLimited = true;
            } else {
                $scope.showLimited = false;
            }
        }
    });

    $scope.requiredFields = ['"Kod Sklepu"'];

    $scope.upload = undefined;
    $scope.fileUploaded = false;
    $scope.errorRequired = false;

    $scope.removeFile = function () {
        $scope.upload = undefined;
        $scope.errorRequired = true;
        $scope.fileUploaded = false;
    };

    $scope.uploadSuccess = function (file) {
        $scope.upload = file;
        $scope.errorRequired = false;
        $scope.fileUploaded = true;
        $scope.fileError = false;
        $scope.$apply();
    };

    $scope.getImportShopsExampleXls = function () {
        $scope.isLoading = false;
        Coupon.getImportShopsExampleXls().then(function (result) {
            let data = result.data;

            angular.openInNewTab(data);
        }).finally(function () {
            $scope.isLoading = false;
        });
    };

    $scope.deleteAllShopsByCouponId = function () {
        $scope.isLoading = true;
        Coupon.deleteAllShopsByCouponId($scope.application_id, $scope.couponId).then(function (result) {
            let data = result.data;

            if (data.success) {
                $state.reload();
                growl.success('MODULES.APPLICATIONS.SUCCESS.SHOPS_DELETED');
            } else if (data.error) {
                growl.error(data.error === 'ERROR.ACCESS_DENIED' ? data.error : 'MODULES.APPLICATIONS.ERROR.SHOPS_DELETED');
            }
        })
            .finally(function () {
                $scope.isLoading = false;
            });
    };

    $scope.showBadgeForShop = function () {
        $scope.show_limited_stores_ui = !$scope.show_limited_stores_ui;
        Coupon.showBadgeForShop($scope.application_id, $scope.couponId, $scope.show_limited_stores_ui);
    };

    function refreshData() {
        $scope.searchShops({refresh: refresh});
        refresh = !refresh;
        $scope.checkedCoupons = [];
    }

    $scope.searchShops = function (search) {
        $scope.isFind = true;

        var find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.searchItem = $scope.search;
        $scope.isFind = false;
    };

    $scope.importShops = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;
        $scope.wrongData = [];

        Coupon.importShops($scope.application_id, $scope.couponId, $scope.upload).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.imported = true;
                $scope.wrongData = data.wrongData;
                $state.reload();
                growl.success('MODULES.APPLICATIONS.MODULES.USERS.IMPORT.SUCCESS');
            } else {
                growl.error(data.error, {title: 'IMPORT.HEADER.DEFAULT'});
            }
        }).finally(function () {
            $scope.isLoading = false;
            refreshData();
        });
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.coupons');
    };

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'MODULES.COUPONS.ERROR.NAME'}]
    };
}]);

couponsControllers.controller('CouponAllImportController', ['$state', '$scope', '$rootScope', '$stateParams', 'growl', 'Coupon', '$filter', '$locale', function ($state, $scope, $rootScope, $stateParams, growl, Coupon, $filter, $locale) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.application_id = $stateParams.application_id;
    $scope.lang = $filter('translate')('LANG');
    if (locales[$scope.lang] && locales[$scope.lang].DATETIME_FORMATS) {
        angular.copy(locales[$scope.lang].DATETIME_FORMATS, $locale.DATETIME_FORMATS);
    }
    $scope.editMode = false;

    $scope.requiredFields = [
        '"forcom_segment_id"',
        '"forcom_counter_id"',
        '"name"',
        '"badge_type"',
        '"start_date"',
        '"validity_date"',
        '"image"',
        '"small_image"'
    ];

    $scope.optionalFields = [
        '"badge_line_1"',
        '"badge_line_2"',
        '"badge_line_3"',
        '"price"',
        '"price_unit"',
        '"measure"',
        '"additional_description"',
        '"additional_description_2"',
        '"additional_description_3"',
        '"clause_1"',
        '"clause_2"',
        '"counter"',
        '"alcohol"',
        '"beer"',
        '"personalized_segment_id"',
        '"type"',
        '"data_visible_from"',
        '"badge_daily_line_1"',
        '"badge_daily_line_2"',
        '"coupon_omnibus_price"',
        '"short_coupon_omnibus_price"',
        '"coupon_omnibus_price_unit"'
    ];

    $scope.upload = undefined;
    $scope.fileUploaded = false;
    $scope.errorRequired = false;

    $scope.removeFile = function () {
        $scope.upload = undefined;
        $scope.errorRequired = true;
        $scope.fileUploaded = false;
    };

    $scope.uploadSuccess = function (file) {
        $scope.upload = file;
        $scope.errorRequired = false;
        $scope.fileUploaded = true;
        $scope.fileError = false;
        $scope.$apply();
    };

    $scope.importAllData = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;
        $scope.wrongData = [];
        Coupon.importAllData($scope.application_id, $scope.upload).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.imported = true;
                $scope.wrongData = data.wrongData;
                growl.success('MODULES.APPLICATIONS.MODULES.USERS.IMPORT.SUCCESS');
                if ($scope.wrongData.length <= 0) {
                    $state.go('appsoup.application.coupons');
                }
            } else {
                growl.error(data.error, {title: 'IMPORT.HEADER.DEFAULT'});
            }
        }).finally(function () {
            $scope.isLoading = false;
        });
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.coupons');
    };

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'MODULES.COUPONS.ERROR.NAME'}]
    };
}]);

couponsControllers.controller('ScratchCardsImportController', ['$state', '$scope', '$rootScope', '$stateParams', 'growl', 'Coupon', '$filter', '$locale', function ($state, $scope, $rootScope, $stateParams, growl, Coupon, $filter, $locale) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.application_id = $stateParams.application_id;
    $scope.lang = $filter('translate')('LANG');
    if (locales[$scope.lang] && locales[$scope.lang].DATETIME_FORMATS) {
        angular.copy(locales[$scope.lang].DATETIME_FORMATS, $locale.DATETIME_FORMATS);
    }
    $scope.editMode = false;

    $scope.requiredFields = [
        '"forcom_segment_id"',
        '"name"',
        '"image"',
        '"type"'
    ];

    $scope.optionalFields = [
        '"additional_description"',
        '"reward_value"',
        '"reward_id"',
        '"reward_use_id"',
        '"reward_name"',
        '"reward_use_name"'
    ];

    $scope.upload = undefined;
    $scope.fileUploaded = false;
    $scope.errorRequired = false;

    $scope.removeFile = function () {
        $scope.upload = undefined;
        $scope.errorRequired = true;
        $scope.fileUploaded = false;
    };

    $scope.uploadSuccess = function (file) {
        $scope.upload = file;
        $scope.errorRequired = false;
        $scope.fileUploaded = true;
        $scope.fileError = false;
        $scope.$apply();
    };

    $scope.importScratchCards = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;
        $scope.wrongData = [];
        Coupon.importScratchCards($scope.application_id, $scope.upload).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.imported = true;
                $scope.wrongData = data.wrongData;
                growl.success('MODULES.APPLICATIONS.MODULES.USERS.IMPORT.SUCCESS');
                if ($scope.wrongData.length <= 0) {
                    $state.go('appsoup.application.coupons');
                }
            } else {
                growl.error(data.error, {title: 'IMPORT.HEADER.DEFAULT'});
            }
        }).finally(function () {
            $scope.isLoading = false;
        });
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.coupons');
    };

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'MODULES.COUPONS.ERROR.NAME'}]
    };
}]);

export default couponsControllers;